import { getErrorCodes } from '@/utils'

const INVALID_CODE = 'code_invalid'

interface Props {
  errorData: any
  isFamilyMember?: boolean
}

/**
 * Check the Eligibility of the user for the signup flow
 */
const isUserEligible = ({ errorData, isFamilyMember = false }: Props) => {
  // The API returns a 'code_invalid' error even if the user is not eligible
  // which means "Not found in the validation CSV"
  // A request to send back a custom error has been submitted to Core Ruby
  // Patient API response errors are different than the Family API response errors
  const errorDetails = isFamilyMember
    ? errorData?.error_details
    : errorData?.cause?.error_details
  const errorCodes = getErrorCodes(errorDetails, [
    isFamilyMember ? 'base' : 'redemptions.base',
  ])

  return !errorCodes.includes(INVALID_CODE)
}

export default isUserEligible
